import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@cmps/ng-bootstrap';
import { NgChartModule } from '@cmps/ng-chart';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonModule,
    CmpsChipModule,
    CmpsFilterModule,
    CmpsIconModule,
    CmpsPortalModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../../common/common.module';
import { CmpsLazyI18nModule } from '../../i18n/i18n.module';
import { CmpsMi2TableModule } from '../table';

import { FractionBarMi2Component } from './frction-bar-mi2-component';
import { FrontlineMi2Component } from './frontline-mi2.component';
import { TranslationIdMap } from './main-fl.i18n';
import { FrontlineMI2PersonRowComponent } from './mi2/frontline-mi2-person-row.component';

@NgModule({
    declarations: [
        FrontlineMi2Component,
        FrontlineMI2PersonRowComponent,
        FractionBarMi2Component,
    ],
    exports: [FrontlineMi2Component],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgbModule,
        SelectModule,
        NgChartModule,
        CmpsCommonModule,
        CmpsChipModule,
        CmpsButtonModule,
        CmpsFilterModule,
        CmpsPortalModule,
        CmpsIconModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsMi2TableModule,
        CmpsTooltipModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CmpsFrontLineMi2Module {}
